import { ApiAuthScene } from '@/components/ApiAuthModal';
import {
  IAddressListParams,
  IBatchUpdateApiInfo,
  IBatchUpdateSubAccountApiByParent,
  ICreateParentPermission,
  ICreateSubAccountApiKey,
  IOneApiInfoParamsByParent,
  IParentApiManagement,
  ISubAccountApiManagement,
  IUpdateIp,
  IUpdateLimitSymbol,
  IUpdateOneApiInfo,
  IUpdateOneSubAccountApiByParent,
  IUpdateSubAccountIp,
} from '@/services/types/apiManagement';
import { ICodeTargetType } from '@/services/types/verify';
import { API2_HOST } from '@/utils/constants';

import fetchData from '../http';
import request from '../request';
import { IBaseResponse } from '../types/common';
import { getParams } from '../verify/index';

// API列表。
export const apiList = () => {
  const url = `${API2_HOST}/api/newList`;
  return request.get(url, {
    useCache: true,
  });
};

// 子账号API列表。
export const apiSubList = (memberId: string | number) => {
  const url = `${API2_HOST}/v3/private/user/member/api-info?memberId=${memberId}`;
  return fetchData.get(url);
};

// API添加。没有使用的接口后续添加ts
export const apiAdd = ({
  note,
  ips,
  permissions,
  verificationCode,
  readOnly,
  appName,
  addressInfo,
  emailCode,
  from,
  riskToken,
  rsa_public_key,
}: ICreateParentPermission) => {
  const url = `${API2_HOST}/api/newAdd`;
  const params = {
    note, // 备注
    ips, // 绑定IPverification_code
    permissions, // 权限
    verification_code: verificationCode, // google验证码
    read_only: readOnly,
    app_name: appName, // 应用名称
    address_info: addressInfo,
    email_code: emailCode,
    from,
    riskToken,
    rsa_public_key,
  };
  return fetchData.post(url, getParams(params));
};

// 子账号API添加。
export const apiSubAccountAdd = ({
  note,
  ips,
  permissions,
  verificationCode,
  readOnly,
  appName,
  memberId,
  riskToken,
  rsa_public_key,
}: ICreateSubAccountApiKey) => {
  const url = `${API2_HOST}/v3/private/user/member/create-apikey`;
  const params = {
    memberId,
    note, // 备注
    ips, // 绑定IP
    permissions, // 权限
    readOnly,
    appName, // 应用名称
    riskToken,
    rsa_public_key,
    authContext: [
      {
        // google2fa固定字符串 5
        target: { type: ICodeTargetType.Google2fa },
        challenge: '',
        // google验证码
        answer: { response: verificationCode },
      },
    ],
  };
  return fetchData.post(url, getParams(params));
};

// API删除。
export const delApi = (apiManagementId: string, riskToken: string) => {
  const url = `${API2_HOST}/api/del`;
  return fetchData.post(
    url,
    // id
    getParams({
      api_management_id: apiManagementId,
      risk_token: riskToken,
    }),
  );
};
// 母账号删除子账号api
export const delSubAccountApi = ({
  apiManagementId,
  subMemberId,
  riskToken,
}: {
  apiManagementId: string;
  subMemberId: string;
  riskToken: string;
}) => {
  const url = `${API2_HOST}/user/private/delete/sub/apikey`;
  return fetchData.post(
    url,
    getParams({
      api_management_id: apiManagementId,
      sub_member_id: subMemberId,
      risk_token: riskToken,
    }),
  );
};

// 子账号/母账号登陆修改IP
export const updateIP = (params: IUpdateIp) => {
  const url = `${API2_HOST}/api/change/bind-ips`;
  return fetchData.post(url, getParams(params));
};

// 母账号修改子账号IP
export const updateSubAccountIP = (params: IUpdateSubAccountIp) => {
  const url = `${API2_HOST}/user/private/change/sub-apikey/whiteip`;
  return fetchData.post(url, getParams(params));
};

// 获取第三方应用列表
export const getAppName = () => {
  const url = `${API2_HOST}/api/application/list`;
  return fetchData.get(url);
};

// 提现地址列表-new
export const newGetAddressList = (params: IAddressListParams) => {
  const url = `${API2_HOST}/v3/private/cht/asset-withdraw/address/address-list`;
  return fetchData.get(url, getParams(params));
};

// 获取母账号单条api详情
export const getOneApiInfo = (apiManagementId: string) => {
  const url = `${API2_HOST}/user/private/query/apikey?api_management_id=${apiManagementId}`;
  return fetchData.get<IBaseResponse<ISubAccountApiManagement>>(url);
};

// 母账号获取子账号单条api详情
export const getOneSubAccountApiByParent = ({
  apiManagementId,
  subMemberId,
}: IOneApiInfoParamsByParent) => {
  const url = `${API2_HOST}/user/private/query/sub-apikey?api_management_id=${apiManagementId}&sub_member_id=${subMemberId}`;
  return fetchData.get<IBaseResponse<IParentApiManagement>>(url);
};

// 母账号修改api
export const updateOneApiInfo = (params: IUpdateOneApiInfo) => {
  const url = `${API2_HOST}/user/private/edit/apikey`;
  return fetchData.post<IBaseResponse<ISubAccountApiManagement>>(
    url,
    getParams(params),
  );
};

// 母账号修改子账号api
export const updateOneSubAccountApiByParent = (
  params: IUpdateOneSubAccountApiByParent,
) => {
  const url = `${API2_HOST}/user/private/edit/sub/apikey`;
  return fetchData.post<IBaseResponse<IParentApiManagement>>(
    url,
    getParams(params),
  );
};

// 母账号批量修改api
export const batchUpdateApiInfo = (params: IBatchUpdateApiInfo) => {
  const url = `${API2_HOST}/user/private/batch-edit/whiteip`;
  return fetchData.post(url, getParams(params));
};
// IBatchUpdateSubAccountApiByParent;

// 母账号批量修改子账号api
export const batchUpdateSubAccountApiByParent = (
  params: IBatchUpdateSubAccountApiByParent,
) => {
  const url = `${API2_HOST}/user/private/batch-edit/sub/whiteip`;
  return fetchData.post(url, getParams(params));
};

// 获取api交易对白名单
export const getLimitSymbol = (params: { apikey: string }) => {
  const url = `${API2_HOST}/user/private/get/limit-symbol?apikey=${params.apikey}`;
  return fetchData.get(url);
};

// 添加/更新交易对白名单
export const updateLimitSymbol = (params: IUpdateLimitSymbol) => {
  const url = `${API2_HOST}/user/private/add/limit-symbol`;
  return fetchData.post(url, getParams(params));
};

// 获取现货所有交易对白名单
export const getSpotSymbol = () => {
  const url = `${API2_HOST}/spot/api/basic/symbol_list`;
  return fetchData.get(url);
};

// 获取所有币种
export const getCoinList = () => {
  // const url = `${API2_HOST}/v3/private/cht/asset-common/coin-list`;
  const url = `${API2_HOST}/cht/asset/page/coin/getAllCoin`;
  return fetchData.post(url, getParams({ coins: [] }));
};

// 获取衍生品交易对列表
export const getContractSymbolList = () => {
  const url = `${API2_HOST}/contract/v5/product/dynamic-symbol-list`;
  return fetchData.get(url);
};

// copper用户授权
// to: 来源r
// from: 1 母账号第一次创建 openAPI 的场景；2 母账号第一次创建子账号时的场景
export const copperAuth = (params: { to: string; from: ApiAuthScene }) => {
  const url = `${API2_HOST}/user/private/authorize/action`;
  return fetchData.post(url, getParams(params));
};

export const upgradeApi = (params: { upTo: string }) => {
  const url = `${API2_HOST}/derivatives/v3/private/account/upgrade-unified-trading-front`;
  return new Promise((resolve, reject) => {
    fetchData
      .post(url, { body: JSON.stringify(params) })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject({
          ...error,
          ret_code: error.retCode || error.ret_code,
          ret_msg: error.retMsg || error.ret_msg,
        });
      });
  });
};

// 查看密钥密码
export const showApiSecret = (params: {
  apikey: string;
  risk_token: string;
}) => {
  const url = `${API2_HOST}/user/private/query/secret`;
  return fetchData.get(url, { body: JSON.stringify(params) });
};
